<template>
    <common-chart :chart-id="id" :options="option"></common-chart>
</template>

<script>
import {_pxGenerator} from "@/components/LayoutMaps/maps/MapFunction";
import CommonChart from "@/components/echarts-part/kpi/stuff/CommonChart.vue";

export default {
    name: "RateGauge",
    components: {CommonChart},
    props: {
        id: String,
        value: String
    },
    computed: {
        option() {
            return {
                series: [
                    {
                        type: 'gauge',
                        detail: {
                            formatter: '{value}%',
                            fontSize: _pxGenerator(0.14),
                            fontWeight: 'bold',
                            color: '#fff'
                        },
                        data: [{value: this.value}],
                        radius: '90%',
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: [[this.value / 100, 'rgb(55, 162, 218)'], [1, 'rgb(13, 37, 81)']],
                                width: _pxGenerator(0.1)
                            }
                        },
                        axisLabel: {            // 坐标轴小标记
                            show: false
                        },
                        splitLine: {           // 分隔线
                            length: '20%',
                            distance: -_pxGenerator(0.08),
                            lineStyle: {
                                color: '#fff',
                                width: _pxGenerator(0.02)
                            },
                        },
                        axisTick: {            // 坐标轴小标记
                            show: false
                        },
                        itemStyle: {
                            color: 'rgb(251, 114, 147)'
                        },
                        pointer: {
                            width: _pxGenerator(0.06)
                        }
                    }
                ]
            };
        }
    },
}
</script>

<style scoped>

</style>